import{defineCustomElement as r}from"./utils/defineCustomElement.js";import{Window as s,Document as d}from"./utils/server-safe-globals.js";import{MediaUIAttributes as o}from"./constants.js";const a=d.createElement("template");a.innerHTML=`
  <style>
    :host {
      pointer-events: none;
      display: inline-block;
      box-sizing: border-box;

      width: auto;
      height: auto;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      min-width: 100%;
      min-height: 100%;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      object-fit: contain;
    }

    :host([${o.MEDIA_HAS_PLAYED}]) img {
      display: none;
    }
  </style>

  <img aria-hidden="true" id="image"/>
`;const c=(t,e)=>{t.style["background-image"]=`url('${e}')`};class n extends s.HTMLElement{static get observedAttributes(){return[o.MEDIA_HAS_PLAYED,"placeholder-src","src"]}constructor(){super();this.attachShadow({mode:"open"}),this.shadowRoot.appendChild(a.content.cloneNode(!0)),this.image=this.shadowRoot.querySelector("#image")}attributeChangedCallback(e,m,i){e==="src"&&this.image.setAttribute("src",i),e==="placeholder-src"&&c(this.image,i)}}r("media-poster-image",n);var u=n;export{u as default};
//# sourceMappingURL=media-poster-image.js.map
